<div class="login-container">
  <div class="row g-0">

    <div class="col-md-6 left-side">
      <!-- Left Side -->
      <app-login-image></app-login-image>
    </div>

    <div class="col-md-6 d-flex justify-content-center align-items-center position-relative">
      <!-- Right Side - Login Form -->
      <div class="login-form">
        <app-logo></app-logo>
        <h2 class="login-title mt-5">Login</h2>
        <form #loginForm="ngForm" (keydown.enter)="login({ page: 'login', form: loginForm })">
          <!-- Email Input with Validation -->
           <div class="col-md-12">
             <app-input  [type]="'email'"
                         [label]="'Email'"
                         [id]="'email'"
                         [name]="'email'"
                         [required]="true"
                         [(ngModel)]="loginAdminUser.Email"
                         [validateNumber]="false"
                         #emailInput="ngModel"
                         [inputMode]="emailInput"></app-input>
           </div>

          <!-- Password Input with Validation -->
           <!-- <div class="col-md-12 mt-4">
             <app-input [type]="'password'"
                        [label]="'Password'"
                        [id]="'password'"
                        [name]="'password'"
                        [required]="true"
                        [(ngModel)]="loginAdminUser.Password"
                        [validateNumber]="false"
                        #passwordInput="ngModel"
                        [inputMode]="passwordInput"></app-input>
           </div> -->

           <div class="col-md-12 mt-4 position-relative password-wrapper">
            <app-input [type]="isPasswordVisible ? 'text' : 'password'"
                      [label]="'Password'"
                      [id]="'password'"
                      [name]="'password'"
                      [required]="true"
                      [(ngModel)]="loginAdminUser.Password"
                      [validateNumber]="false"
                      #passwordInput="ngModel"
                      [inputMode]="passwordInput"></app-input>
            
            <button type="button" 
                    class="password-toggle-btn" 
                    (click)="togglePasswordVisibility()"
                    aria-label="Toggle password visibility">
              <i class="bi font-size-18" [ngClass]="isPasswordVisible ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>

          <!-- Login Button -->
           <div class="col-md-12 mt-4">
             <app-button [buttonText]="'Login'"
                         [btnClassName]="'btn-login text-white'" 
                         [page]="'login'" 
                         [form]="loginForm" 
                         [buttonColor]="'#EF8936'"
                         [loading]="isLoading"
                         (buttonClick)="login($event)"></app-button>
           </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- <app-loading [isLoading]="isLoading"></app-loading> -->